<div
  class="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4"
>
  <div class="w-full max-w-4xl bg-white rounded-xl shadow-lg overflow-hidden">
    <!-- Header -->
    <div class="bg-blue-600 text-white p-6 text-center">
      <h1 class="text-3xl font-bold">
        Bienvenido, {{ nombres }} {{ apellidos }}
      </h1>
      <p class="text-blue-100 mt-1">{{ getNameRol() }}</p>
    </div>

    <!-- Contenido principal -->
    <div class="p-6">
      <!-- Grid de opciones -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div
          *ngFor="let option of options"
          class="option-card bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
          (click)="navigateTo(option.route)"
        >
          <div class="p-6 text-center">
            <div
              class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-50 mb-4"
            >
              <i [class]="option.icon" class="text-2xl text-blue-600"></i>
            </div>
            <h2 class="text-lg font-semibold text-gray-800">
              {{ option.name }}
            </h2>
          </div>
        </div>
      </div>

      <!-- Botón de salir -->
      <div class="mt-10 text-center">
        <button
          class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
          (click)="logout()"
        >
          <i class="fas fa-sign-out-alt mr-2"></i> Cerrar sesión
        </button>
      </div>
    </div>
  </div>
</div>
